import { useEffect, useRef, useState } from "react";

export default function useNetworkWatcher() {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const prevStatusRef = useRef<boolean>(navigator.onLine); // lưu trạng thái trước đó

  useEffect(() => {
    const checkConnection = () => {
      const currentStatus = navigator.onLine;
      // Cập nhật state và ref
      setIsOnline(currentStatus);
      prevStatusRef.current = currentStatus;
    };

    // Kiểm tra lần đầu khi mount
    checkConnection();

    // Gắn listener cho online/offline
    window.addEventListener("online", checkConnection);
    window.addEventListener("offline", checkConnection);

    // Kiểm tra định kỳ mỗi 5s
    const intervalId = setInterval(checkConnection, 5000);

    // Cleanup
    return () => {
      window.removeEventListener("online", checkConnection);
      window.removeEventListener("offline", checkConnection);
      clearInterval(intervalId);
    };
  }, []);

  return isOnline;
}
